var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"help"}},[_c('iframe',{staticStyle:{"height":"100%","width":"100%"},attrs:{"marginwidth":"1","marginheight":"1","scrolling":"none","frameborder":"0","src":_vm.$store.state.userinfo.jiaocheng}})])}
var staticRenderFns = []

export { render, staticRenderFns }